import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const botones = [
  { label: "Ambiente de Control", to: "/ControlInterno/ComponentesCI/AmbienteControl" },
  { label: "Actividades de Control", to: "/ControlInterno/ComponentesCI/ActividadesControl" },
  { label: "Administración de Riesgos", to: "/ControlInterno/ComponentesCI/AdministracionRiesgos" },
  { label: "Información y Comunicación", to: "/ControlInterno/ComponentesCI/InformacionComunicacion" },
  { label: "Supervisión", to: "/ControlInterno/ComponentesCI/Supervision" }
];

const ComponentesCI = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        <div className="row justify-content-center gap-3">
          {botones.map((btn, idx) => (
            <div key={idx} className="col-12 col-md-5 d-flex justify-content-center">
              <Link to={btn.to} className="ci-nav__btn--pill">
                {btn.label}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ComponentesCI;
